import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Watcher from './Watcher';

import T from 'i18n-react';

(function loadLanguage() {
    let languageData = {
        en: require('./lang/en.yaml'),
        ca: require('./lang/ca.yaml'),
        es: require('./lang/es.yaml')
    };
    let language = 'en';
    let languages;
    if (navigator.languages) {
        languages = navigator.languages;
    } else {
        languages = [navigator.language];
    }
    languages.some(l => {
        if (l in languageData) {
            language = l;
            return true;
        }
        l = l.split('-')[0];
        l = l.split('_')[0];
        if (l in languageData) {
            language = l;
            return true;
        }
        return false;
    });
    T.setTexts(languageData[language]);
})();

let watch = window.location.search.indexOf('watch') !== -1;

if (watch) {
    ReactDOM.render(<Watcher/>, document.querySelector('#sceneContainer'));
} else {
    ReactDOM.render(<App/>, document.querySelector('#sceneContainer'));
}
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js